import React from "react";
import "./table.css";
import Button from "../../widgets/button";
import ReactHtmlParser from "html-react-parser";
import { generateExcel } from "../table/table.utils";
import StatusDropdown, { Status } from "../../modules/scheduling/statusDropdown";
import Edit from "../../img/edit.svg";

export interface headerType {
  label: string;
  style?: {
    alignment?: {
      textAlign?: "left" | "center" | "right";
      verticalAlign?: "top" | "middle" | "bottom";
      color?: string;
    };
  };
    headerColor?: string; 
  exlStyle?: {
    alignment?: {
      horizontal?: "left" | "center" | "right";
    };
    width?: number;
  };
}

interface TableButtonProps {
  btnClassName: string;
  btnName: string;
  btnType?: string;
  btnSrc?: string;
  btnColHeading?: string;
  alwaysShow?: boolean;
}

interface TableProps {
  id?: string;
  tableHeading?: string;
  classNames?: string;
  classNameTable?: string;
  headers: headerType[];
  data: string[][];
  actionButtons?: React.ReactNode;
  exportExcel?: boolean;
  fileName?: string;
  buttonsClass?: TableButtonProps[];
  onClickButton1?: (id1: number) => void;
  onClickButton2?: (id1: number) => void;
  onClickButton3?: (id1: number) => void;
  onClickButton4?: (id1: number) => void;
  onClickButton5?: (id1: number) => void;
  onClickButton6?: (id1: number) => void;
  onClickButton7?: (id1: number) => void;
}

const Table: React.FC<TableProps> = ({
  id,
  tableHeading,
  headers,
  classNames,
  classNameTable,
  data,
  exportExcel,
  fileName,
  buttonsClass,
  onClickButton1,
  onClickButton2,
  onClickButton3,
  onClickButton4,
  onClickButton5,
  onClickButton6,
  onClickButton7,
}) => {
  //get only data as per columns
  const excelData: string[][] = [];
  if (data) {
    data.forEach((row, i) => {
      excelData[i] = [];
      headers.forEach((header, index) => {
        excelData[i].push(row[index]);
      });
    });
  }
  const statuses: Status[] = [
    { label: "PRIORITY", value: "priority", color: "priority" },
    { label: "READY FOR MULCH", value: "readyformulch", color: "readyformulch" },
    // { label: "PENDING", value: "pending", color: "pending" },
    { label: "HOLD", value: "hold", color: "hold" },
    { label: "TRENCHING", value: "trenching", color: "trenching" },
    { label: "MOVE FROM LIST", value: "movefromlist", color: "movefromlist" },
  ];

  const getStatusesForRow = (row: string[]) => {
    const scheduledDate = (row[1] ?? "")
      .toString()
      .replace(/<[^>]*>/g, "")
      .trim()
      .toUpperCase();

    if (
      scheduledDate === "READY" ||
      scheduledDate === "READY FOR MULCH"
    ) {
      return statuses.filter((status) => status.value !== "readyformulch");
    }

    if (scheduledDate === "PRIORITY") {
      return statuses.filter((status) => status.value !== "priority");
    }

    if (scheduledDate === "HOLD") {
      return statuses.filter((status) => status.value !== "hold");
    }

    if (scheduledDate === "PENDING") {
      return statuses.filter((status) => status.value !== "pending");
    }

    return statuses;
  };

  const handleStatusChange = (status: Status, rowId: number) => {
    if (status.value === "priority") {
      onClickButton5?.(rowId);
    } else if (status.value === "readyformulch") {
      onClickButton4?.(rowId);
    } else if (status.value === "movefromlist") {
      onClickButton6?.(rowId);
    } else if (status.value === "hold") {
      onClickButton7?.(rowId);
    }
  };

  return (
    <>
      {exportExcel ? (
        <div
          className={`py-2 d-flex align-items-center ${tableHeading ? "tableHeading" : ""} justify-content-between`}
        >
          <div><h6 className="table-heading">{tableHeading}</h6></div>
          <Button
            data="Export"
            className="btn btn-sm approveBtn ml-auto"
            onClick={() => generateExcel(headers, excelData, fileName)}
          />{" "}
        </div>
      ) : null}

      <div
        className={`bcmk-table table-responsive fixTableHead ${classNameTable}`}
      >
        <table className={`table table-striped ${classNames} responsive`}>
          <thead>
            <tr>
              {headers.map((header, index) =>
                buttonsClass && index === 0 ? null : (
                          <th
  key={index}
  style={{
    ...(header.style?.alignment ?? { textAlign: "left" }),
    ...(header.headerColor ? { color: header.headerColor } : {}),
  }}
>
  {header.label}
</th>

                )
              )}
              {buttonsClass?.map((btn, classindex) => (
                <th
                  key={classindex}
                  className={
                    id === "scheduledJobs" && classindex === 1
                      ? "scheduled-job-status-heading"
                      : undefined
                  }
                >
                  {btn["btnColHeading"]}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {!data
              ? null
              : data.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((cell, cellIndex) =>
                    buttonsClass && cellIndex === 0 ? null : cellIndex >
                      headers.length - 1 ? (
                      <></>
                    ) : (
                      <td
                        key={cellIndex}
                         className={cellIndex === 1 ? "scheduled-date" : ""}
                        style={
                          (() => {
                            const alignment = headers[cellIndex].style?.alignment;
                            if (!alignment) return { textAlign: "left" };
                            const { color, ...rest } = alignment as any;
                            return rest;
                          })()
                        }
                        data-label={headers[cellIndex].label}
                      >
                        {(() => {
                          const alignment = headers[cellIndex].style?.alignment as any;
                          const color = alignment?.color as string | undefined;
                          if (typeof cell === "string") {
                            const parsed = ReactHtmlParser(cell);
                            return color ? (
                              <span style={{ color }}>{parsed as React.ReactNode}</span>
                            ) : (
                              parsed
                            );
                          }
                          return cell;
                        })()}
                      </td>
                    )
                  )}
                  {buttonsClass?.map((btn, classindex) => {
                    const shouldShowButton =
                      btn["alwaysShow"] ||
                      row[headers.length + classindex] === "1";

                    switch (classindex) {
                      case 0:
                        return btn.btnType === "Button" ? (
                          <td
                            className={
                              id == "scheduledJobs" ? "schtd" : "w-1"
                            }
                          >
                            {shouldShowButton ? (
                              <button
                                key={`${rowIndex} + ${classindex}`}
                                className={`${btn.btnClassName}`}
                                onClick={() =>
                                  onClickButton1?.(parseInt(row[0]))
                                }
                              >
                                {btn.btnName}
                              </button>
                            ) : row[headers.length + classindex] != "" ? (
                              <div
                                className="w-1 text-success"
                                style={{ paddingTop: "10px" }}
                              >
                                {row[headers.length + classindex]}
                              </div>
                            ) : null}
                          </td>
                        ) : (
                       <td
                        className={id === "scheduledJobs" ? "" : "w-1"}
                        data-label={btn.btnColHeading === "Map" ? "Map" : undefined}
                      >
                        <img
                          key={`${rowIndex}-${classindex}`}
                          className={btn.btnClassName}
                          alt="Map Icon"
                          onClick={() => onClickButton1?.(parseInt(row[0]))}
                          src={btn.btnSrc}
                        />
                      </td>

                        );
                      case 1:
                        return btn.btnType === "Button" ? (
                          <td
                            className={
                              id == "scheduledJobs" ? "d-flex justify-content-end gap-20 align-items-center" : "w-1"
                            }
                          >
                            {shouldShowButton ? (
                              <div className="d-flex justify-content-end gap-20 align-items-center">
                              <button
                                key={`${rowIndex} + ${classindex} `}
                                className={`${btn.btnClassName}`}
                                onClick={() =>
                                  onClickButton2?.(parseInt(row[0]))
                                }
                              >
                                {btn.btnName}
                              </button>
                                <img
                              key={`${rowIndex} + ${classindex}`}
                              className="edit-property-icon"
                              alt="Edit Property"
                              width={20}
                              height={20}
                              onClick={() =>
                                onClickButton3?.(parseInt(row[0]))
                              }
                              src={Edit}
                            />
                              <StatusDropdown
                                statuses={getStatusesForRow(row)}
                                defaultStatus="pending"
                                onChange={(status) =>
                                  handleStatusChange(status, parseInt(row[0]))
                                }
                              />
                            </div>
                            ) : row[headers.length + classindex] != "" ? (
                              <div className="w-1 text-success">
                                {row[headers.length + classindex]}
                              </div>
                            ) : null}
                          </td>
                        ) : (
                          <td
                            className={
                              id == "scheduledJobs" ? "schtd" : "w-1"
                            }
                          >
                            <img
                              key={`${rowIndex} + ${classindex}`}
                              className={`${btn.btnClassName}`}
                              alt="Map Icon"
                              onClick={() =>
                                onClickButton2?.(parseInt(row[0]))
                              }
                              src={`${btn.btnSrc}`}
                            />
                          </td>
                        );
                      case 2:
                        return btn.btnType === "Button" ? (
                          <td
                            className={
                              id == "scheduledJobs" ? "schtd" : "w-1"
                            }
                          >
                            {shouldShowButton ? (
                              <button
                                key={`${rowIndex} + ${classindex} `}
                                className={`${btn.btnClassName}`}
                                onClick={() =>
                                  onClickButton3?.(parseInt(row[0]))
                                }
                              >
                                {btn.btnName}
                              </button>
                            ) : row[headers.length + classindex] != "" ? (
                              <div className="w-1 text-success border-0">
                                {row[headers.length + classindex]}
                              </div>
                            ) : null}
                          </td>
                        ) : (
                          <td
                            className={
                              id == "scheduledJobs" ? "schtd" : "w-1"
                            }
                          >
                            <img
                              key={`${rowIndex} + ${classindex}`}
                              className={`${btn.btnClassName}`}
                              alt="Map Icon"
                              onClick={() =>
                                onClickButton3?.(parseInt(row[0]))
                              }
                              src={`${btn.btnSrc}`}
                            />
                          </td>
                        );

                      case 3:
                        return btn.btnType === "Button" ? (
                          <td
                            className={
                              id == "scheduledJobs" ? "schtd" : "w-1"
                            }
                          >
                            {shouldShowButton ? (
                                <StatusDropdown
                                statuses={getStatusesForRow(row)}
                                defaultStatus="pending"
                                onChange={(status) =>
                                  handleStatusChange(status, parseInt(row[0]))
                                }
                              />
                            ) : row[headers.length + classindex] != "" ? (
                              <div className="w-1 text-success border-0">
                                {row[headers.length + classindex]}
                              </div>
                            ) : null}
                          </td>
                        ) : (
                          <td
                            className={
                              id == "scheduledJobs" ? "schtd" : "w-1"
                            }
                          >
                            <img
                              key={`${rowIndex} + ${classindex}`}
                              className={`${btn.btnClassName}`}
                              alt="Map Icon"
                              onClick={() =>
                                onClickButton4?.(parseInt(row[0]))
                              }
                              src={`${btn.btnSrc}`}
                            />
                          </td>
                        );
                      case 4:
                        return btn.btnType === "Button" ? (
                          <td
                            className={
                              id == "scheduledJobs" ? "schtd" : "w-1"
                            }
                          >
                            {shouldShowButton ? (
                              <button
                                key={`${rowIndex} + ${classindex} `}
                                className={`${btn.btnClassName}`}
                                onClick={() =>
                                  onClickButton5?.(parseInt(row[0]))
                                }
                              >
                                {btn.btnName}
                              </button>
                            ) : row[headers.length + classindex] != "" ? (
                              <div className="w-1 text-success border-0">
                                {row[headers.length + classindex]}
                              </div>
                            ) : null}
                          </td>
                        ) : (
                          <td
                            className={
                              id == "scheduledJobs" ? "schtd" : "w-1"
                            }
                          >
                            <img
                              key={`${rowIndex} + ${classindex}`}
                              className={`${btn.btnClassName}`}
                              alt="Map Icon"
                              onClick={() =>
                                onClickButton5?.(parseInt(row[0]))
                              }
                              src={`${btn.btnSrc}`}
                            />
                          </td>
                        );
                      default:
                        return btn.btnType === "Button" ? (
                          row[headers.length + classindex] === "1" ? (
                            <td
                              className={
                                id == "scheduledJobs" ? "schtd" : "w-1"
                              }
                            >
                              <button
                                key={`${rowIndex} + ${classindex} `}
                                className={`${btn.btnClassName}`}
                                onClick={() =>
                                  onClickButton2?.(parseInt(row[0]))
                                }
                              >
                                {btn.btnName}
                              </button>
                            </td>
                          ) : row[headers.length + classindex] != "" ? (
                            <td className="w-1">
                              <div className="w-1 text-success border-0">
                                {row[headers.length + classindex]}
                              </div>
                            </td>
                          ) : (
                            <td>null</td>
                          )
                        ) : (
                          <td
                            className={
                              id == "scheduledJobs" ? "schtd" : "w-1"
                            }
                          >
                            <img
                              key={`${rowIndex} + ${classindex}`}
                              className={`${btn.btnClassName}`}
                              alt="Map Icon"
                              onClick={() =>
                                onClickButton2?.(parseInt(row[0]))
                              }
                              src={`${btn.btnSrc}`}
                            />
                          </td>
                        );
                    }
                  })}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Table;
